import script from "./BlogSimilarCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogSimilarCard.vue?vue&type=script&lang=ts&setup=true"

import "./BlogSimilarCard.vue?vue&type=style&index=0&id=05119544&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05119544"]])

export default __exports__